import { type FC, type ReactNode } from "react";

/**
 * Labeled row primitive used across the actor identity sections.
 *
 * Extracted from the former InfoTab god component so each section composes
 * the same label/content layout without re-inlining the flex + typography.
 * The fixed-width label column keeps every section's values aligned.
 */
export const InfoRow: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => (
  <div className="flex items-start gap-4 px-4 py-3 transition-colors hover:bg-emerald-400/[0.02]">
    <p className="w-24 flex-shrink-0 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-emerald-700/80 dark:text-emerald-300/60">
      {label}
    </p>
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);
